import { useIntl } from 'react-intl';
import { IconArrowLeft } from '@rossum/ui/icons/tabler';
import { Alert, Button, Stack, SvgIcon } from '@rossum/ui/material';
import { SIMPLE_COMPONENT_WIDTH } from './constants';

const MissingValues = ({ onBackClick }: { onBackClick?: () => void }) => {
  const intl = useIntl();

  return (
    <Stack
      p={2}
      alignItems="flex-start"
      spacing={2}
      sx={{ width: SIMPLE_COMPONENT_WIDTH }}
    >
      {onBackClick && (
        <Button
          variant="text"
          size="small"
          color="inherit"
          startIcon={
            <SvgIcon fontSize="large">
              <IconArrowLeft />
            </SvgIcon>
          }
          onClick={() => onBackClick()}
          data-cy="all-documents-filter-back-button"
        >
          {intl.formatMessage({ id: 'containers.filtering.buttons.back' })}
        </Button>
      )}
      <Stack alignItems="center" width={1}>
        <Alert color="warning" closeText="Close">
          {intl.formatMessage({ id: 'containers.filtering.valuesAreMissing' })}
        </Alert>
      </Stack>
    </Stack>
  );
};

export { MissingValues };
